import CallDealerForm from './component';

export const Component = CallDealerForm;
export default CallDealerForm;
